module.exports = __webpack_public_path__ + "img/favicon.33ca2b5e.png";